import React, {Component} from 'react';
import { Redirect } from 'react-router';

class Welcome extends Component {
  componentDidUpdate(prevProps) {
    this.props.history.push('/premium');
  }

  render = () => {
    return (
      <Redirect to='/premium' />
    );
    {/*return (
      <div className="flex-container box">
        <h3>Welcome! Sign up or sign in!</h3>
      </div>
    );*/}
  }

};

export default Welcome;
